import { useFormik, FormikProvider } from "formik";
import { useTheme } from "styled-components";
import * as Yup from "yup";
import Button from "../Button/Button";
import TextField from "../FormFields/TextField";
import Icon from "../Icon/Icon";
import Modal, { ModalCard } from "../Modal/Modal";
import { CompanyModel } from "../../views/Company/company.model";
import { createCompany } from "../../views/Company/manageCompany";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Authorized from "../Auth/Authorized";
import { SettingsState } from "../Settings/settingsReducer";
import ToggleSwitchField from "../FormFields/ToggleSwitchField";
import { useAlert } from "../Alert/Alerts";

export const NewCompanyModal = (props: NewCompanyModalProps) => {
  const theme = useTheme();
  const { addNewAlert } = useAlert();
  const { labels } = useSelector((state: RootState) => state.labels);
  const fieldRequired = "This field is required";

  const blankCompanyModel: CompanyModel = {
    name: "",
    isCanonical: false,
  };

  async function PostAddCompany(AddCompany: any) {
    try {
      const newCompany: CompanyModel = {
        name: AddCompany.name,
        isCanonical: AddCompany.isCanonical,
      };

      const response = await createCompany(newCompany);
      if (response?.status == 201) {
        if (response.data && response.data.id) {
          window.open(`/edit-company/${response.data.id}`);
        }
        props.onClickHide();
        formikProps.resetForm();
      }
    } catch (error: any) {
      addNewAlert({
        type: "error",
        message: "Company could not be Created",
      });
    }
  }

  const formikProps = useFormik({
    initialValues: blankCompanyModel,
    enableReinitialize: true,
    onSubmit: (values) => {
      PostAddCompany(values);
    },
    validationSchema: Yup.object({
      name: Yup.string().required(fieldRequired),
    }),
    validateOnBlur: false,
    validateOnChange: false,
  });

  return (
    <Modal show={props.show}>
      <ModalCard
        className="!min-h-[250px] !w-[500px]"
        title={`Add ${labels.company.singular}`}
        headerIcons={
          <Icon
            icon="close"
            color={theme.colorCopyLightLight}
            onClick={props.onClickHide}
          />
        }
        iconColor={theme.colorCopyLightLight}
      >
        <div className="flex flex-col py-[1.5625rem] px-[1.5625rem] gap-[1.5625rem]">
          <FormikProvider value={formikProps}>
            <TextField
              name="name"
              placeholder={`${labels.company.singular} Name`}
            />
            <Authorized
              settings={props.settings}
              loading={props.loading}
              feature="Canonical Company"
              authorized={
                <ToggleSwitchField
                  name="isCanonical"
                  label={` Is ${labels.canonical.singular} ${labels.company.singular}?`}
                  checked={formikProps.values.isCanonical}
                  id={"isCanonical"}
                />
              }
            />
            <Button
              className="w-auto ml-auto"
              iconLeft="plus"
              iconColor={theme.colorCopyLightLight}
              onClick={formikProps.submitForm}
              type="submit"
            >
              Add
            </Button>
          </FormikProvider>
        </div>
      </ModalCard>
    </Modal>
  );
};

interface NewCompanyModalProps {
  show: boolean;
  settings: SettingsState;
  loading: boolean;
  onClickHide(): void;
}
